import { Permission } from '../types';

/**
 * Permission modules that only make sense for a Restaurant-module company
 * (drive the /restaurant/* pages) — hidden from the role permission tree
 * for every other module.
 */
const RESTAURANT_ONLY_MODULES = ['Menu', 'Outlets', 'Orders', 'Modifiers', 'Packages'];

/**
 * Permission modules tied to the retail-style sales-invoice flow — hidden
 * for a Restaurant-module company, which uses its own Order flow instead.
 * Till and Customers are intentionally excluded: those stay common to all
 * modules.
 */
const NON_RESTAURANT_ONLY_MODULES = ['SalesInvoices'];

/** Filters a permission list down to the modules relevant to the company's business module. */
export function filterPermissionsByModule(permissions: Permission[], companyModuleCode: string): Permission[] {
  const isRestaurant = companyModuleCode === 'restaurant';
  return permissions.filter((p) => {
    if (RESTAURANT_ONLY_MODULES.includes(p.module)) return isRestaurant;
    if (NON_RESTAURANT_ONLY_MODULES.includes(p.module)) return !isRestaurant;
    return true;
  });
}
